module.exports = __webpack_public_path__ + "static/email-0c6f2fc2e448709ffe844aebe9e6d4f9.png";